import routes from '@routes';
import { CacheProps, fetchApi } from '../../fetch';

interface SearchInputProps extends CacheProps {
  searchQuery: string
}

const usersSearchApi = ({ searchQuery, ...rest }: SearchInputProps) => {
  return fetchApi({
    method: 'POST',
    URL: routes['api.users.datatable'],
    payload: {
      limit: '10',
      sort: 'id',
      direction: 'asc',
      type_id: '1',
      full_name: searchQuery,
    },
    ...rest,
  });
};

export default usersSearchApi;
